import BookmarkFilledIcon from "@heroicons/react/24/solid/BookmarkIcon";
import SparklesIcon from "@heroicons/react/24/solid/SparklesIcon";
import ButtonBase from "@mui/material/ButtonBase";
import { styled as styling } from "@mui/material/styles";
import Color from "../../../../assets/colors";
import { P } from "../styles";

export const Wrapper = styling("div")({
  display: "flex",
  flexDirection: "column",
  gap: "1rem",

  margin: "2rem 0",
});

export const JobListContainer = styling("div")({
  display: "grid",
  gridTemplateColumns: "repeat(3, 1fr)",
  gap: "1rem",

  "@media (max-width: 1279px)": {
    gridTemplateColumns: "repeat(2, 1fr)",
  },

  "@media (max-width: 640px)": {
    display: "flex",
    overflowY: "hidden",
    overflowX: "auto",
    scrollBehavior: "smooth",
    scrollSnapType: "x mandatory",

    "-webkit-scrollbar, ::-webkit-scrollbar": {
      display: "none",
    },
  },
});

export const JobCard = styling("div")({
  backgroundColor: Color.white,
  border: `1px solid ${Color.grey}`,
  borderRadius: "0.5rem",

  display: "flex",
  flexDirection: "column",
  justifyContent: "space-between",

  height: "120px",
  width: "100%",
  padding: "0.625rem 0.625rem 0.875rem",
  minWidth: 0,
  maxWidth: "100%",

  "@media (max-width: 640px)": {
    height: "148px",
    width: "280px",

    scrollSnapAlign: "center",
    scrollSnapStop: "always",
  },
});

export const ChipContainer = styling("div")({
  display: "flex",
  flexWrap: "wrap",
  gap: "0.375rem",

  height: "100%",
  marginBottom: "0.875rem",
});

export const CompanyDetailContainer = styling("div")({
  display: "flex",
  alignItems: "center",
  gap: "0.75rem",

  width: "calc(100% - 24px)",
  minWidth: 0,
});

export const HeaderText = styling(P)({
  color: Color.black,
  fontSize: "1.25rem",
  fontWeight: "700",
  lineHeight: "24px",
});

export const JobTitle = styling("h3")({
  color: Color.textMediumEmphasis,

  flex: "1 1 auto",

  fontSize: "0.875rem",
  fontWeight: "700",
  lineHeight: "24px",
  letterSpacing: "0.1px",
  textOverflow: "ellipsis",
  whiteSpace: "nowrap",
  overflow: "hidden",

  margin: "0",
  width: "100%",
});

export const CompanyName = styling("h4")({
  color: Color.textMediumEmphasis,

  flex: "1 1 auto",

  fontSize: "0.625rem",
  fontWeight: "400",
  lineHeight: "20px",
  letterSpacing: "1.5px",
  textTransform: "uppercase",
  textOverflow: "ellipsis",
  whiteSpace: "nowrap",
  overflow: "hidden",

  margin: "0",
  minWidth: 0,
});

export const JobDetailChip = styling("span")((props) => ({
  background: Color.backgroundGrey,
  color: Color.textMediumEmphasis,
  borderRadius: "0.25rem",

  fontSize: "0.625rem",
  fontWeight: "700",
  textWrap: "nowrap",

  height: "21px",
  padding: "0.1875rem 0.62rem",

  "@media (max-width: 640px)": {
    ...(props.type === "jobType" && {
      color: Color.blue,
      backgroundColor: "rgba(33, 61, 181, 0.14)",
    }),
    ...(props.type === "state" && {
      color: "rgba(129, 155, 72, 1)",
      backgroundColor: "rgba(129, 155, 72, 0.14)",
    }),
    ...(props.type === "salary" && {
      color: "rgba(155, 72, 72, 1)",
      backgroundColor: "rgba(155, 72, 72, 0.14)",
    }),
  },
}));

export const JobBoostChip = styling("span")({
  background: Color.lightHiredlyPurple,
  color: Color.darkPurple,
  borderRadius: "0.25rem",
  border: `1px solid ${Color.darkPurple}`,

  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  flexShrink: 0,

  fontSize: "0.625rem",
  fontWeight: "400",
  lineHeight: "20px",
  letterSpacing: "1.5px",
  textTransform: "uppercase",

  height: "20px",
  width: "51px",
  padding: "0px 5px",
  margin: "0 0 0 8px",
});

export const CompanyLogo = styling("img")({
  objectFit: "contain",

  borderRadius: "0.375rem",
  boxShadow: "0px 1px 4px 0px rgba(0, 0, 0, 0.25)",

  height: "26px",
  width: "26px",
});

export const BookmarkButton = styling(ButtonBase)((props) => ({
  borderRadius: "0.25rem",
  flexShrink: 0,
  width: "24px",

  transition: "all 0.15s ease-in-out",

  ...(props.disabled && {
    pointerEvents: "none",
    cursor: "not-allowed",
    opacity: "0.5",
  }),
}));

export const SparklesIconStyled = styling(SparklesIcon)({
  width: "10px",
  height: "10px",
});

export const SaveIcon = styling(BookmarkFilledIcon)({
  color: Color.white,
  stroke: Color.hiredlyPurple,
  strokeWidth: "1.5",

  height: "20px",
  width: "20px",

  transition: "all 0.15s ease-in-out",
  "&:hover": {
    strokeWidth: "2",
  },
});

export const UnsaveIcon = styling(BookmarkFilledIcon)({
  color: Color.hiredlyPurple,
  strokeWidth: "1.5",
  height: "20px",
  width: "20px",

  transition: "all 0.15s ease-in-out",

  "&:hover": {
    strokeWidth: "2",
  },
});
